import styled, { keyframes } from 'styled-components'

import {
  black,
  brandSecondary,
  fontWeightBold,
  hardcoreAnimationEase,
  media,
} from '../../../../../../utils/style-utils'

interface Props {
  active: boolean
}

const lastChildAnimationIn = keyframes`
  from {
    transform: translateX(500px);
    opacity: 0;
  }
`

const firstChildAnimationIn = keyframes`
  from {
    transform: translateX(-500px);
    opacity: 0;
  }
`

export const InlineText = styled.div<Props>`
  display: none;

  ${media.md`
    position: absolute;
    z-index: 2;
    bottom: 0;
    width: 100%;
    height: 2rem;
    display: flex;
    gap: 0.5rem;

    justify-content: center;
    align-items: center;

    background: ${black};

    span:first-child {
      text-transform: uppercase;
      font-weight: ${fontWeightBold};

      animation: ${firstChildAnimationIn} 1s ${hardcoreAnimationEase};
      ${({ active }: Props) => (!active ? 'animation: none' : '')};
    }

    span:last-child {
      color: ${brandSecondary};
      animation: ${lastChildAnimationIn} 1s ${hardcoreAnimationEase};
      ${({ active }: Props) => (!active ? 'animation: none' : '')};
    }
  `}
`
